import { of } from 'rxjs'
import { delayWhen, filter, startWith, switchMap, take } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { filtersCall } from 'api/planet/filters'
import { DATE_FILTERS_FORMAT } from 'constants/dateFormats'
import { getDepartureCitiesFromTransportation, getDepartureDatesFromOffset } from 'domain/filters'
import { awaitForSaleFetched } from 'store/epics/helpers'
import * as Actions from 'store/actions/index.ts'
import {
  getBeginDate,
  getCities,
  getCountryCode,
  getCultureCode,
  getDepartureCitiesFiltersFromQuery,
  getDurationsFiltersFromQuery,
  getIsSaleFetched,
  getMarketId,
  getOperationCode,
  getSaleKey,
  getSelectedDepartureDatesOffsetsRangeListFromQuery,
  getSelectedDepartureDatesSettingsFromQuery,
  getSelectedTransportationFromQuery,
  getShouldDoubleThePriceFeatureEnabled
} from 'store/selectors'

const initFiltersEpic = (actions$, state$) => actions$.pipe(
  ofType(Actions.member.MEMBER_INFO_FETCHED),
  take(1),
  delayWhen(() => {
    const resourceFetched$ = actions$.pipe(ofType(Actions.resources.RESOURCE_FETCHED))

    return (getIsSaleFetched(state$.value))
      ? of({})
      : awaitForSaleFetched(resourceFetched$, state$)
  }),
  filter((action) => (
    action?.payload?.response?.selection === undefined
  )),
  switchMap(() => {
    const state = state$.value

    const beginDate = getBeginDate(state)
    const countryCode = getCountryCode(state)
    const cultureCode = getCultureCode(state)
    const marketId = getMarketId(state)
    const saleKey = getSaleKey(state)
    const operationCode = getOperationCode(state)
    const departureCities = getDepartureCitiesFiltersFromQuery(state)
    const durations = getDurationsFiltersFromQuery(state)
    const transportation = getSelectedTransportationFromQuery(state)
    const isResourceV2 = getShouldDoubleThePriceFeatureEnabled(state)
    const cities = getCities(state)

    const departureDatesSettings = getSelectedDepartureDatesSettingsFromQuery(state)
    const departureDatesRange = getSelectedDepartureDatesOffsetsRangeListFromQuery(state)
    const departureDates = getDepartureDatesFromOffset(beginDate, DATE_FILTERS_FORMAT)(departureDatesRange)

    if (departureCities.length || departureDates.length || durations.length || (transportation === 'included' || transportation === 'none')) {
      return filtersCall(
        countryCode,
        cultureCode,
        getDepartureCitiesFromTransportation(cities, departureCities, transportation),
        departureDates,
        durations,
        marketId,
        operationCode,
        saleKey,
        isResourceV2
      ).pipe(
        switchMap(({ response: { products } }) => (
          of(Actions.filters.onFiltersFetched(products))
        )),
        startWith(Actions.filters.onInitFilters(departureCities, departureDatesSettings, durations, transportation)),
        startWith(Actions.filters.onFiltersFetchStarted())
      )
    }
    return of(Actions.filters.onInitFilters(departureCities, departureDatesSettings, durations, transportation))
  })
)

export default initFiltersEpic
